export default "__VITE_ASSET__rNxDVvGI__"